import React, { Component } from "react";
import MainPage from "./mainCards/mainPage";

class Main extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  toggle = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };



  render() {
    const { loader, Courses, user, firstCourseID } = this.props;
    return (
      <div>
        <MainPage
          onPageChange={this.props.onPageChange}
          courses={Courses}
          firstCourseID={firstCourseID}
          loader={loader}
          user={user}
        />
      </div>
    );
  }
}
export default Main;
